import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Field, Form } from 'formik';
import { Box, Button } from '@components/common';
import { InputField, SelectField } from '@components/form';
import PropertyField from '@containers/properties/PropertyField';
import API from '@utils/api';
import validationSchema from './schema';
import { AuthSelectors } from '@redux/AuthRedux';
import AppActions from '@redux/AppRedux';
import BookingActions from '@redux/BookingRedux';
import { arry2KeyValue } from '@utils/object';
import { getErrors } from '@utils/error';
import { transformInitialAppData } from '@services/transform';

class InputUnitForm extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onNext: PropTypes.func,
    setRecipient: PropTypes.func,
    setAppData: PropTypes.func,
    setProperty: PropTypes.func,
    user: PropTypes.object
  };

  handleSubmit = async (values, actions) => {
    const { onSubmit, setRecipient, setAppData, setProperty } = this.props;
    const { setSubmitting, setErrors } = actions;
    setSubmitting(true);

    try {
      const {
        property,
        bedroomsCount,
        residentName,
        email,
        unitNumber,
        buildingName
      } = values;
      const { result: pricing } = await API.getPMPricings({
        propertyID: property.propertyID,
        bedroomsCount: bedroomsCount.value
      });

      setProperty(property);
      setAppData(pricing);

      const [firstName, lastName] = residentName.split(' ');
      setRecipient({
        propertyID: property.propertyID,
        propertyName: property.name,
        bedroomsCount: bedroomsCount.value,
        buildingName: buildingName.value,
        email,
        firstName,
        lastName: lastName || '',
        unitNumber
      });
      setSubmitting(false);
      onSubmit();
    } catch (err) {
      const error = getErrors(err);
      if (error.message) {
        setErrors({
          residentName: error.message
        });
      } else {
        setErrors(error);
      }
    }
    setSubmitting(false);
  };

  render() {
    return (
      <Formik
        initialValues={{
          property: null,
          bedroomsCount: '',
          buildingName: '',
          unitNumber: '',
          residentName: '',
          email: ''
        }}
        onSubmit={this.handleSubmit}
        validationSchema={validationSchema}
      >
        {({ isValid, isSubmitting, values }) => {
          const { property } = values;
          const hasMultipleBuildings =
            property &&
            property.buildingsNames &&
            property.buildingsNames.length > 0;

          const buildingNames =
            property && property.buildingsNames
              ? arry2KeyValue(property.buildingsNames)
              : [];
          const bedRooms =
            property && property.bedroomsCounts
              ? arry2KeyValue(property.bedroomsCounts, 'Bedroom', {
                  0: {
                    value: 0,
                    label: 'Studio'
                  }
                })
              : [];

          return (
            <Form>
              <Box display="flex" flexDirection="column">
                <Field
                  mb={4}
                  component={PropertyField}
                  name="property"
                  label="Building name"
                />

                {hasMultipleBuildings && (
                  <Field
                    component={SelectField}
                    mb={4}
                    name="buildingName"
                    label="Building"
                    options={buildingNames}
                  />
                )}
                <Field
                  component={InputField}
                  mb={4}
                  disabled={!property}
                  name="unitNumber"
                  type="text"
                  label="Unit Number"
                />
                <Field
                  component={SelectField}
                  disabled={!property}
                  isSearchable={false}
                  mb={4}
                  name="bedroomsCount"
                  label="Number of Bedrooms"
                  options={bedRooms}
                />
                <Field
                  component={InputField}
                  mb={4}
                  name="email"
                  type="email"
                  label="Email Address"
                />
                <Field
                  component={InputField}
                  mb={4}
                  name="residentName"
                  type="text"
                  label="Resident name"
                />
                <Button flex={1} mb={4} type="submit" disabled={isSubmitting}>
                  Continue
                </Button>
              </Box>
            </Form>
          );
        }}
      </Formik>
    );
  }
}

const mapStatesToProps = state => ({
  user: AuthSelectors.selectCurrentUser(state)
});

const mapDispatchToProps = dispatch => ({
  setRecipient: data => dispatch(BookingActions.setBookingRecipient(data)),
  setProperty: data => dispatch(BookingActions.setBookingProperty(data)),
  setAppData: result => {
    const transformed = transformInitialAppData(result);
    dispatch(AppActions.setAppData(transformed));
  }
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(InputUnitForm);
